<template>
  <div class="action-configuration">
    <component
      :is="actionComponent"
      :step="step"
      :allFields="allFields"
      :currentEntity="currentEntity"
      :entity_id="currentEntity._id"
      :allEntities="allEntities"
      :allEntityFilters="allEntityFilters"
      :allContacts="allContacts"
      :companyUsers="companyUsers"
      :allTemplates="allTemplates"
      :templateFieldMap="templateFieldMap"
      :allTemplateFieldMap="allTemplateFieldMap"
      :companyAllTemplateFields="companyAllTemplateFields"
      :allFormbuilders="allFormbuilders"
      :trigger="trigger"
      :entityAllFilters="entityAllFilters"
      :entityRelationships="entityRelationships"
      @update:step="updateStep"
      @close:step="closeStep"
    />
  </div>
</template>

<script>
  import { actionComponents } from './index';

  export default {
    name: 'ActionConfigurationBase',
    components: {
      ...actionComponents,
    },
    props: {
      step: Object,
      allFields: Array,
      currentEntity: Object,
      allEntities: {
        type: Array,
        default: () => [],
      },
      allEntityFilters: Object,
      entityAllFilters: Array,
      trigger: Object,
      allContacts: Array,
      companyUsers: Array,
      allTemplates: Array,
      templateFieldMap: Object,
      allTemplateFieldMap: Object,
      companyAllTemplateFields: Object,
      allFormbuilders: Array,
      entityRelationships: Array,
    },
    computed: {
      actionComponent() {
        const actionMap = {
          'other/REFRESH_ENTITY': 'RefreshEntityAction',
          'other/ALLOCATE': 'AutoAllocateAction',
          'other/ALLOCATION': 'AllocateUserForm',
          'formbuilder/SEND_APPROVAL': 'SendApprovalAction',
          'formbuilder/ADD_FORM': 'SendFormBuilderAction',
          'self/doc_template/SEND_DOC_TEMPLATE': 'SendDocTemplateAction',
          'file/ADD_FOLDER': 'AddFolderAction',
          'file/DELETE_FOLDER': 'DeleteFolderAction',
          'self/UPDATE': 'SelfUpdateAction',
          'self/SEND EMAIL': 'SendEmailAction',
          'self/SEND WHATSAPP MESSAGE': 'SendWhatsappAction',
          'self/SEND_WORKFLOW': 'SendWorkflowAction',
          'self/AUTOMATE': 'AutomateAction',
          'self/CREATE_CONTACT': 'CreateContactAction',
          'other/UPDATE': 'OtherUpdateAction',
          'other/ADD': 'OtherAddAction',
          'other/AUTOMATE': 'OtherAddAction',
        };
        return actionMap[this.step.action] || 'DefaultAction';
      },
    },
    methods: {
      updateStep(data) {
        Object.keys(data || {}).forEach((e) => {
          this.$set(this.step, e, data[e]);
        });
        this.$emit('close');
      },
      closeStep() {
        this.$emit('close');
      },
    },
  };
</script>
